var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _PreTreatmentFilledJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import BaseTreatmentFilledJournalEvent, { TreatmentSectionWithColor } from "./base-treatment-filled-journal-event";
import Patient from "./patient";
let PreTreatmentFilledJournalEvent = (_dec = attr("boolean", {
  allowNull: true
}), _dec2 = attr("boolean", {
  allowNull: true
}), _dec3 = attr("boolean", {
  allowNull: true
}), _dec4 = attr("boolean", {
  allowNull: true
}), _dec5 = attr("boolean", {
  allowNull: true
}), _dec6 = attr("boolean", {
  allowNull: true
}), _dec7 = attr("boolean", {
  allowNull: true
}), _dec8 = belongsTo("patient", {
  async: false,
  inverse: "preTreatmentFilledJournalEvents"
}), _class = (_PreTreatmentFilledJournalEvent = class PreTreatmentFilledJournalEvent extends BaseTreatmentFilledJournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "pacPainful", _descriptor, this);
    _initializerDefineProperty(this, "pacInflammatory", _descriptor2, this);
    _initializerDefineProperty(this, "pacFlowing", _descriptor3, this);
    _initializerDefineProperty(this, "pacHealing", _descriptor4, this);
    _initializerDefineProperty(this, "radiotherapy", _descriptor5, this);
    _initializerDefineProperty(this, "cortisone", _descriptor6, this);
    _initializerDefineProperty(this, "cortisoneDosageGt20", _descriptor7, this);
    //---- End of generated code ----
    _initializerDefineProperty(this, "patient", _descriptor8, this);
  }
  get sectionsWithColor() {
    return [...this.baseSectionsWithColor, {
      key: "pac-painful",
      label: "Port-à-cath douloureux",
      color: this.pacPainful ? "red" : "green",
      answers: this.pacPainful ? ["Oui"] : ["Non"]
    }, {
      key: "pac-inflammatory",
      label: "Port-à-cath inflammatoire",
      color: this.pacInflammatory ? "red" : "green",
      answers: this.pacInflammatory ? ["Oui"] : ["Non"]
    }, {
      key: "pac-flowing",
      label: "Port-à-cath avec écoulement",
      color: this.pacFlowing ? "red" : "green",
      answers: this.pacFlowing ? ["Oui"] : ["Non"]
    }, {
      key: "pac-healing",
      label: "Port-à-cath avec cicatrisation difficile",
      color: this.pacHealing ? "red" : "green",
      answers: this.pacHealing ? ["Oui"] : ["Non"]
    }, {
      key: "radiotherapy",
      label: "Radiothérapie",
      color: this.radiotherapy ? "red" : "green",
      answers: this.radiotherapy ? ["Oui"] : ["Non"]
    }, {
      key: "cortisone",
      label: "Cortisone",
      color: this.cortisone ? "red" : "green",
      answers: this.cortisone ? ["Oui"] : ["Non"]
    }, {
      key: "cortisone-dosage-gt20",
      label: "Cortisone - dosage > 20mg",
      color: this.cortisoneDosageGt20 ? "red" : "green",
      answers: this.cortisoneDosageGt20 ? ["Oui"] : ["Non"]
    }];
  }
}, _defineProperty(_PreTreatmentFilledJournalEvent, "type", "pre-treatment-filled-journal-event"), _defineProperty(_PreTreatmentFilledJournalEvent, "sections", ["temperatureIssue", "temperature", "fatigueIssue", "fatigue", "coughIssue", "cough", "breathIssue", "breath", "currentWeight", "weightLossIssue", "weightLoss", "pacPainful", "pacInflammatory", "pacFlowing", "pacHealing", "dermatologicalIssue", "skinRashIssue", "skinRashLocation", "itchingIssue", "itchingLocation", "dermatologicalTreatmentEfficient", "skinRashIssue", "skinRashLocation", "itchingIssue", "itchingLocation", "nauseaVomitingIssue", "nauseaVomiting", "diarrheaIssue", "diarrhea", "constipationIssue", "constipation", "constipationTreatmentEfficient", "painIssue", "pain", "muscularPainIssue", "muscularPainLevel", "muscularPainLocation", "muscularPainTreatmentEfficient", "articularPainIssue", "articularPainLevel", "articularPainLocation", "articularPainTreatmentEfficient", "otherPainIssue", "otherPainLocation", "otherPainTreatmentEfficient", "cortisone", "cortisoneDosageGt20", "radiotherapy"]), _PreTreatmentFilledJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "pacPainful", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "pacInflammatory", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "pacFlowing", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "pacHealing", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "radiotherapy", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "cortisone", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "cortisoneDosageGt20", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { PreTreatmentFilledJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.